import { components } from 'react-select';

export function MultiValueWithoutLimit(props) {
  return <components.MultiValue {...props} />;
}
